// extracted by mini-css-extract-plugin
export default {"gridBody":"StandardsDataGrid__gridBody___ClKkI","outlineHiddenGridBody":"StandardsDataGrid__outlineHiddenGridBody___VEQDm"};